import { useEffect } from "react";
import { useTutorialTrigger } from "../../hooks/useTutorialTrigger";
import { useTutorialStore } from "../../stores/tutorialStore";
import { useSpaceStore } from "../../stores";
import { TutorialOverlay } from "./TutorialOverlay";
import { TUTORIAL_STEPS } from "./TutorialStepContent";
import "./Tutorial.css";

export function TutorialProvider() {
	const hydrate = useTutorialStore((s) => s.hydrate);
	const isHydrated = useTutorialStore((s) => s.isHydrated);
	const isActive = useTutorialStore((s) => s.isActive);
	const isDismissed = useTutorialStore((s) => s.isDismissed);
	const currentStep = useTutorialStore((s) => s.currentStep);
	const completedPhases = useTutorialStore((s) => s.completedPhases);
	const resetTutorial = useTutorialStore((s) => s.resetTutorial);

	const setActiveTab = useSpaceStore((s) => s.setActiveTab);

	// Hydrate tutorial state from localStorage on mount
	useEffect(() => {
		hydrate();
	}, [hydrate]);

	// Auto-switch tabs when tutorial step requires it
	useEffect(() => {
		if (!isActive || !isHydrated) return;
		const stepDef = TUTORIAL_STEPS[currentStep];
		if (stepDef?.requiresTab && setActiveTab) {
			setActiveTab(stepDef.requiresTab);
		}
	}, [isActive, isHydrated, currentStep, setActiveTab]);

	// Auto-advance interaction listeners
	useTutorialTrigger();

	if (!isHydrated) return null;

	const showReplay =
		!isActive && (isDismissed || completedPhases.size >= 5);

	return (
		<>
			{isActive && <TutorialOverlay />}
			{showReplay && (
				<button
					type="button"
					className="tutorial-replay-btn"
					onClick={resetTutorial}
					title="Replay tutorial"
				>
					?
				</button>
			)}
		</>
	);
}
